/* Opt-in truck banner shared by workspace pages. */
[data-workspace-page-header].workspace-truck-banner {
  container: workspace-truck-banner / inline-size;
  gap: 0;
  padding: 0;
  border: 1px solid var(--color-line-soft);
  border-radius: 4px;
  background: white;
}
.workspace-truck-banner > div:first-child {
  position: relative;
  isolation: isolate;
  min-height: 70px;
  padding: 6px calc(20px + clamp(280px, 30cqw, 400px)) 6px 20px;
  align-items: center;
}
.workspace-truck-banner > div:first-child::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 0 auto;
  width: 54%;
  max-width: 434px;
  border-radius: 0 3px 3px 0;
  content: "";
  background: url("/brand/reports/transia-grain-banner.png") right center / auto 100% no-repeat;
  mask-image: linear-gradient(90deg, transparent 10%, rgb(0 0 0 / 0.025) 18%, rgb(0 0 0 / 0.10) 26%, rgb(0 0 0 / 0.30) 34%, rgb(0 0 0 / 0.60) 42%, rgb(0 0 0 / 0.86) 48%, black 56%);
}
.workspace-truck-banner > div:first-child h1 {
  font-size: clamp(24px, 2.2cqw, 28px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.035em;
}
.workspace-truck-banner > div:first-child [aria-hidden='true']:has(> svg) { width: 32px; height: 32px; }
.workspace-truck-banner > div:first-child [aria-hidden='true'] > svg { width: 20px; height: 20px; }
.workspace-truck-banner > div:first-child p { font-size: 13px; line-height: 1.4; color: var(--color-slate-800); }
.workspace-truck-banner > div + div { padding: 12px 20px; }
@media (max-width: 979px) {
  .workspace-truck-banner > div:first-child { min-height: 0; padding: 12px 16px; }
  .workspace-truck-banner > div:first-child::before { display: none; background-image: none; }
  .workspace-truck-banner > div + div { padding: 12px 16px; }
}
@container workspace-truck-banner (max-width: 719px) {
  .workspace-truck-banner > div:first-child { min-height: 0; padding: 12px 16px; }
  .workspace-truck-banner > div:first-child::before { display: none; background-image: none; }
  .workspace-truck-banner > div:first-child [aria-hidden='true']:has(> svg) { width: 40px; height: 40px; }
  .workspace-truck-banner > div:first-child p { font-size: 15px; }
  .workspace-truck-banner > div + div { padding: 12px 16px; }
}
